/**
 * The site's motion, in one place.
 *
 * A count of what was here before this file: **five** independent systems doing
 * the same job — an element appearing as you scroll to it.
 *
 * 1. `RevealOnScroll` + a `.reveal` class (IntersectionObserver, 700ms, 24px)
 * 2. the same observer written out again inline inside `ImpactBento`
 * 3. `scroll-reveal-shell` / `scroll-reveal-item`, a rAF scroll listener in two
 *    components writing a `--scroll-reveal` custom property — which no rule in
 *    any stylesheet ever read. Two sections ran a handler on every scroll frame
 *    to animate nothing.
 * 4. framer-motion's `useInView` scaling FAQ rows from 0.85
 * 5. CSS keyframes (`hero-fade`, `home-hero-*`) whose classes no component used
 *
 * Different curves, different distances, different durations, different
 * triggers. That is why sections which should have felt like one page felt like
 * a stack of separately-authored screens.
 *
 * One entrance now — rise and fade — declared as `@keyframes flou-reveal` in
 * globals.css and applied by `<Reveal>`:
 *
 *   travel     16px          enough to read as motion, not as a jump
 *   duration   460ms         the old 700ms was still moving after your thumb
 *                            had stopped, so the page read as lagging behind you
 *   easing     cubic-bezier(0.22, 1, 0.36, 1)
 *                            decelerating hard, so an element arrives rather
 *                            than drifting into place
 *
 * Those three live in the stylesheet because that is the only place that can
 * use them; duplicating them here as exported constants would just be a second
 * set of numbers to keep in sync. The stagger is the exception — React has to
 * compute it per element — so it is the one value this file owns.
 *
 * Anything needing more than this is a signature moment (the hero wordmark, the
 * marquees) and is written by hand.
 */

/** Gap between siblings in a staggered group. Six items = 300ms, not 1.2s. */
export const REVEAL_STAGGER_MS = 60
